module.exports = __webpack_public_path__ + "img/customers.909e911c.svg";